import { EntityListResponse } from '@ydistri/api-sdk';
import React from 'react';
import { IconButton_IconSizes, Row, Text } from '@ydistri/ds';

import DefaultEntityListIcon from '../../../../../components/domain/EntityLists/DefaultEntityListIcon';
import EntityListTypeBadge from '../../../../../components/domain/EntityLists/EntityListTypeBadge';
import EntityListSourceTypeIcon from '../../../../../components/domain/EntityLists/EntityListSourceTypeIcon';
import ArchivedEntityListIcon from '../../../../../components/domain/EntityLists/ArchivedEntityListIcon';

interface EntityListSelectOptionProps {
  entityList: EntityListResponse;
  type?: 'default' | 'compact';
}

const EntityListSelectOption: React.FC<EntityListSelectOptionProps> = ({
  entityList,
  type = 'default',
}) => {
  if (type === 'compact') {
    return (
      <Row $gap="0.5rem" $justifyContent="space-between" $minWidth="10rem">
        <EntityListTypeBadge
          typeNames={entityList.entityListTypes.map(t => t.entityListTypeName)}
        />
        <Row $gap="0.25rem" $flexGrow={1} $alignItems="center" $minWidth="12rem">
          <Text>{entityList.name}</Text>
          {entityList.isDefault && <DefaultEntityListIcon />}
          {entityList.isArchived && <ArchivedEntityListIcon />}
        </Row>
      </Row>
    );
  }

  return (
    <Row $gap="0.5rem" $justifyContent="flex-start" $minWidth="20rem">
      <Row $gap="0.25rem" $alignItems="center" $minWidth="12rem" $flexGrow={1}>
        <Text>{entityList.name}</Text>
        {entityList.isDefault && <DefaultEntityListIcon />}
        {entityList.isArchived && <ArchivedEntityListIcon />}
      </Row>
      <Row $minWidth="11rem">
        <EntityListTypeBadge
          typeNames={entityList.entityListTypes.map(t => t.entityListTypeName)}
        />
      </Row>
      <Row $gap="8px" $minWidth="8rem">
        <EntityListSourceTypeIcon
          entityListSourceType={entityList.entityListSourceTypeId}
          size={IconButton_IconSizes.small}
          entityListId={entityList.entityListId}
          customerEntityListId={entityList.customerEntityListId}
          entityListVersionId={entityList.lastEntityListVersionId}
        />
        <Text>{entityList.entityListSourceTypeId}</Text>
      </Row>
    </Row>
  );
};

export default EntityListSelectOption;
